import React from 'react';
import { BaseComponent } from './BaseComponent.js';
import { BaseTemplate } from './BaseTemplate.js';
import $ from 'jquery';
import FontAwesome from 'react-fontawesome';
import { NavLink  } from 'react-router-dom';
import Toggle from 'react-toggle';

export class SingleDevice extends BaseComponent {
  constructor(props) {
    super(props);

    this.state = {
      url: 'https://sparkjvm.com/cloud/json',
      api: 'GetDevices',
      urlTunnel: 'https://sparkjvm.com/cloud/json',
      apiTunnel: 'CreateTunnel',
      deviceID: parseInt(props.match.params.id, 10),
      device: '',
      tunnel: {
        URL: '',
      },
      apps: '',
      overlayActive: 0,
      overlayLoaded: 0,
      overlayData: '',
      subdevices: '',
      monitoring: false,
      alarms: [],
      pageLoaded: 1,
      alarmUnidata: 0,
      showMonitoring: false
    };

    this.openApp = this.openApp.bind(this);
    this.closeApp = this.closeApp.bind(this);
    this.iframeLoad = this.iframeLoad.bind(this);
    this.toggleMonitoring = this.toggleMonitoring.bind(this);
    this.removeAlarm = this.removeAlarm.bind(this);
    this.getAlarms = this.getAlarms.bind(this);
    this.createEventAndRule = this.createEventAndRule.bind(this);
    this.enableEventAndRule = this.enableEventAndRule.bind(this);
    this.disableEventAndRule = this.disableEventAndRule.bind(this);
  }

  componentDidMount() {
    this.getDevices();
    this.createTunnel();
  }

  getDevices() {
    $.ajax({
      method: 'POST',
      url: this.state.url,
      headers: {
        'x-session': this.props.token,
      },
      data: JSON.stringify({
        Action: this.state.api
      }),
      xhrFields: {
        withCredentials: true
      },
      dataType: 'JSON',
      success: (res) => {
        if (res.Devices) {
          let i = 0;
          while (i < res.Devices.length) {
            if (res.Devices[i].id === this.state.deviceID) {
              this.setState({ device: res.Devices[i] });
            }
            i++;
          }
        }
      },
      error: (httpReq, status, exception) => {
        this.checkLoginStatus();
      },
    });
  }

  createTunnel() {
    $.ajax({
      method: 'POST',
      url: this.state.urlTunnel,
      headers: {
        'x-session': this.props.token,
      },
      data: JSON.stringify({
        Action: this.state.apiTunnel,
        DeviceID: this.state.deviceID,
      }),
      xhrFields: {
        withCredentials: true
      },
      dataType: 'JSON',
      success: (res) => {
        if (res.Tunnel) {
          this.setState({ tunnel: res.Tunnel });
          this.requestApps();
          this.requestSubdevices();
          this.getAlarms();
          this.setState({ pageLoaded: 1 });
        }
      },
      error: (httpReq, status, exception) => {
        this.checkLoginStatus();
      },
    });
  }

  requestApps() {
    $.ajax({
      method: 'GET',
      url: this.state.tunnel.URL + '/apps/json',
      headers: {
        'x-session': this.props.token,
      },
      xhrFields: {
        withCredentials: true
      },
      dataType: 'JSON',
      success: (res) => {
        if (res.Apps) {
          this.setState({ apps: res.Apps });
        } else {
          this.setState({ apps: false });
        }
      },
      error: (httpReq, status, exception) => {
        this.checkLoginStatus();
      },
    });
  }

  requestSubdevices() {
    $.ajax({
      method: 'GET',
      url: this.state.tunnel.URL + '/zigbee/json',
      headers: {
        'x-session': this.props.token,
      },
      dataType: 'json',
      xhrFields: {
        withCredentials: true
      },
      success: (resZigbee) => {
        $.ajax({
          method: 'GET',
          url: this.state.tunnel.URL + '/energy/storage/json',
          headers: {
            'x-session': this.props.token,
          },
          dataType: 'json',
          xhrFields: {
            withCredentials: true
          },
          success: (resModbus) => {
            console.log(resModbus);
            let res = [];
            if (resZigbee.Nodes) {
              res = resZigbee.Nodes;
              if (resModbus.length) {
                res = res.concat(resModbus);
              }

              this.setState({ subdevices: res });
            } else {
              if (resModbus.length) {
                res = res.concat(resModbus);
              }

              this.setState({ subdevices: res });
            }
          },
          error: (httpReq, status, exception) => {
            console.log(httpReq);
            console.log(status);
            console.log(exception);

            let res = [];
            if (resZigbee.Nodes) {
              res = resZigbee.Nodes;
              this.setState({ subdevices: res });
            } else {
              this.setState({ subdevices: res });
            }
          },
        });
      },
      error: (httpReq, status, exception) => {
        console.log(httpReq);
        console.log(status);
        console.log(exception);
      },
    });
  }

  renderApps() {
    if (this.state.apps && this.state.apps.length) {
      const listApps = this.state.apps.map((app) =>
        <div key={ app.UUID } data-uuid={ app.UUID } className="single-device__content__apps__app" onClick={ this.openApp }>
          <div className="single-device__content__apps__app__content">
            <img className="single-device__content__apps__app__content__img" src={ this.state.tunnel.URL + app.Icon } alt={ app.name } />
            <span className="single-device__content__apps__app__content__name">{ app.Name }</span>
            <FontAwesome name="arrow-right" />
          </div>
        </div>
      );
      return(
        <div className="single-device__content__apps">{ listApps }</div>
      )
    } else if(this.state.apps === false) {
      return(
        <div className="single-device__content__apps__none">
          Nessuna app presente sul dispositivo
        </div>
      );
    }
    return(
      <div className="single-device__content__apps__none">
        Caricamento applicazioni...
      </div>
    );
  }

  renderSubdevices() {
    if (this.state.subdevices && this.state.subdevices.length) {
      const listSubdevices = this.state.subdevices.map((subdevice) => {
        let active;
        if (subdevice.Active === true) {
          active = 'Attivato';
        } else if(subdevice.Active === false) {
          active = 'Disattivato';
        }
        // MODBUS STATE
        if (!active) {
          active = subdevice.Status;
        }
        let type;
        if (subdevice.Endpoints && subdevice.Endpoints.length) {
          type = subdevice.Endpoints[0].DeviceType;
        }
        let address = subdevice.IEEEAddress;
        // MODBUS
        if (!address) {
          address = subdevice.Id;
        }
        return(
          <NavLink key={ address } to={ '/devices/device-' + this.state.deviceID + '/sub-' + encodeURI(address) } className="single-device__content__subdevices__subdevice">
            <div className="single-device__content__subdevices__subdevice__content">
              <span className="single-device__content__subdevices__subdevice__content__active">{ active }</span>
              <span className="single-device__content__subdevices__subdevice__content__name">{ subdevice.Description }</span>
              <span className="single-device__content__subdevices__subdevice__content__type">{ type }</span>
            </div>
          </NavLink>
        );
      });
      return(
        <div className="single-device__content__subdevices">{ listSubdevices }</div>
      )
    } else if(this.state.subdevices === false) {
      return(
        <div className="single-device__content__subdevices__none">
          Nessun dispositivo connesso
        </div>
      );
    }
    return(
      <div className="single-device__content__subdevices__none">
        Caricamento dispositivi connessi...
      </div>
    );
  }

  renderOverlay() {
    if (this.state.overlayActive) {
      let iframeUrl = this.state.tunnel.URL + this.state.overlayData.HomePage + '?rtsp=' + this.state.tunnel.RTSP.OverHTTP;
      return(
        <div className="overlay">
          <div className="overlay__shadow" onClick={ this.closeApp }></div>
          <div className="overlay__content">
            { this.renderLoader() }
            <iframe title={ this.state.overlayData.Name } className="overlay__content__iframe" src={ iframeUrl } onLoad={ this.iframeLoad }></iframe>
          </div>
        </div>
      )
    }
    return '';
  }

  openApp(e) {
    let uuid = $(e.currentTarget).data('uuid');
    let i = 0;
    while (i < this.state.apps.length) {
      if (uuid === this.state.apps[i].UUID) {
        this.setState({ overlayData: this.state.apps[i] });
      }
      i++;
    }
    this.setState({ overlayActive: 1 });
  }

  closeApp() {
    this.setState({ overlayActive: 0 });
    this.setState({ overlayLoaded: 0 });
  }

  renderLoader() {
    if (!this.state.overlayLoaded) {
      return(
        <div className="loader">
          <div className="loader__content">
            <FontAwesome
              className='loader__content__icon'
              name='spinner'
              spin
            />
          </div>
        </div>
      );
    }
  }

  renderLoaderPage() {
    if (!this.state.pageLoaded) {
      return(
        <div className="loader">
          <div className="loader__content">
            <FontAwesome
              className='loader__content__icon'
              name='spinner'
              spin
            />
          </div>
        </div>
      );
    }
  }

  renderMonitoring() {
    if (this.state.showMonitoring) {
      return(
        <Toggle
          checked={ this.state.monitoring }
          onChange={ this.toggleMonitoring }
        />
      );
    }
    return(
      <div>Caricamento dati...</div>
    );
  }

  iframeLoad() {
    this.setState({ overlayLoaded: 1 });
  }

  createEventAndRule() {
    $.ajax({
      method: 'POST',
      url: this.state.tunnel.URL + '/alarms/json',
      headers: {
        'x-session': this.props.token,
      },
      data: JSON.stringify({
        Command: 'Add',
        Alarm: {
          Name: 'unidata',
          Interval: 30,
          EventType: 'Store',
        }
      }),
      xhrFields: {
        withCredentials: true
      },
      dataType: 'JSON',
      success: (res) => {
        this.getAlarms();

        $.ajax({
          method: 'POST',
          url: this.state.tunnel.URL + '/eca/json',
          headers: {
            'x-session': this.props.token,
          },
          data: JSON.stringify({
            Command: 'AddEventSource',
            EventSource: {
              Name: 'unidata',
              URI: '/alarms/event',
              Event: 'Store',
            }
          }),
          xhrFields: {
            withCredentials: true
          },
          dataType: 'JSON',
          success: (res) => {
            console.log(res);

            $.ajax({
              method: 'POST',
              url: this.state.tunnel.URL + '/eca/json',
              headers: {
                'x-session': this.props.token,
              },
              data: JSON.stringify({
                Command: 'AddRule',
                Rule: {
                  Name: 'unidata',
                  Enable: true,
                  EventSource: 'unidata',
                  Condition: 'true',
                  Scene: 'Cloud',
                  ExternalVariables: [{
                    URI: '/zigbee/json',
                    Variables: [{
                      Name: 'data',
                      XPath: '.',
                    }],
                  }],
                }
              }),
              xhrFields: {
                withCredentials: true
              },
              dataType: 'JSON',
              success: (res) => {
                console.log(res);
              },
              error: (httpReq, status, exception) => {
                this.checkLoginStatus();
              },
            });
          },
          error: (httpReq, status, exception) => {
            this.checkLoginStatus();
          },
        });
      },
      error: (httpReq, status, exception) => {
        this.checkLoginStatus();
      },
    });
  }

  enableEventAndRule() {
    console.log('CHIAMATA AJAX PER ATTIVARE LE REGOLE');
  }

  disableEventAndRule() {
    console.log('CHIAMATA AJAX PER DISATTIVARE LE REGOLE');
    $.ajax({
      method: 'GET',
      url: this.state.tunnel.URL + '/alarms/json',
      headers: {
        'x-session': this.props.token,
      },
      xhrFields: {
        withCredentials: true
      },
      dataType: 'JSON',
      success: (res) => {
        let i = 0;
        while (i < res.Alarms.length) {
          if (res.Alarms[i].Name === 'unidata') {
            this.removeAlarm(res.Alarms[i]);
          }
          i++;
        }
        this.getAlarms();
      },
      error: (httpReq, status, exception) => {
        this.checkLoginStatus();
      },
    });

    $.ajax({
      method: 'GET',
      url: this.state.tunnel.URL + '/eca/json',
      headers: {
        'x-session': this.props.token,
      },
      xhrFields: {
        withCredentials: true
      },
      dataType: 'JSON',
      success: (res) => {
        console.log(res);
        let j = 0;
        while (j < res.Rules.length) {
          if (res.Rules[j].Name === 'unidata') {
            this.removeRule(res.Rules[j]);
          }
          j++;
        }

        let i = 0;
        while (i < res.EventSources.length) {
          if (res.EventSources[i].Name === 'unidata') {
            this.removeEventSource(res.EventSources[i]);
          }
          i++;
        }
      },
      error: (httpReq, status, exception) => {
        this.checkLoginStatus();
      },
    });
  }

  removeEventSource(eventSource) {
    $.ajax({
      method: 'POST',
      url: this.state.tunnel.URL + '/eca/json',
      headers: {
        'x-session': this.props.token,
      },
      data: JSON.stringify({
        Command: 'RemoveEventSource',
        Id: eventSource.Id,
      }),
      xhrFields: {
        withCredentials: true
      },
      dataType: 'JSON',
      success: (res) => {
        console.log(res);
      },
      error: (httpReq, status, exception) => {
        this.checkLoginStatus();
      },
    });
  }

  removeRule(rule) {
    $.ajax({
      method: 'POST',
      url: this.state.tunnel.URL + '/eca/json',
      headers: {
        'x-session': this.props.token,
      },
      data: JSON.stringify({
        Command: 'RemoveRule',
        Id: rule.Id,
      }),
      xhrFields: {
        withCredentials: true
      },
      dataType: 'JSON',
      success: (res) => {
        console.log(res);
      },
      error: (httpReq, status, exception) => {
        this.checkLoginStatus();
      },
    });
  }

  toggleMonitoring(e) {
    let checked = e.target.checked;
    //this.setState({ monitoring: checked });

    this.setState({ pageLoaded: 0 });
    console.log(checked);
    if (checked) {
      // CREARE TOOL DI MONITORAGGIO
      /*
      1) Si aggiunge un timer che scatta ogni 15min (900 secondi)
      curl --data '{"Command": "Add", "Alarm": {"Name": "Periodic measurement", "Interval": 900, "EventType": "Store"}}' http://127.0.0.1/alarms/json

      2) Nel sistema di gestione degli eventi si indica come sorgente l'allarme precedente
      curl --data '{"Command": "AddEventSource", "EventSource": {"Name": "Periodic measurement", "URI": "/alarms/event", "Event": "Store"}}' http://127.0.0.1/eca/json

      3) Si indica che al verificarsi dell'evento bisogna spedire il contenuto di tutto /zigbee/json
      curl --data '{"Command": "AddRule", "Rule": {"Name": "Periodic measurement", "Enable": true, "EventSource": "Periodic measurement", "Condition": "true", "Scene": "Cloud", "ExternalVariables": [{"URI": "/zigbee/json", "Variables": [{"Name": "data", "XPath": "."}]}]}}' http://127.0.0.1/eca/json

      La "Scene" Cloud già esiste e spedisce il messaggio con il soggetto "Store" (che è il nome dell'evento) che scrive nella coda 0, per specificare una coda diversa il soggetto deve essere "Store[n]" dove n è il numero della coda.
      */
      if (this.state.tunnel.URL) {
        if (!this.state.alarmUnidata) {
          this.createEventAndRule();
        } else {
          this.enableEventAndRule();
        }
      }
    } else {
      console.log('exit');
      // RIMUOVERE TOOL DI MONITORAGGIO
      if (this.state.tunnel.URL) {
        this.disableEventAndRule();
      }
    }
  }

  getAlarms() {
    setTimeout(() => {
      $.ajax({
        method: 'GET',
        url: this.state.tunnel.URL + '/alarms/json',
        headers: {
          'x-session': this.props.token,
        },
        xhrFields: {
          withCredentials: true
        },
        dataType: 'JSON',
        async: false,
        success: (res) => {
          this.setState({ alarms: res.Alarms});
          let i = 0;
          let monitoring = false;
          let alarmUnidata = false;
          while (i < res.Alarms.length) {
            if (res.Alarms[i].Name === 'unidata') {
              monitoring = true;
              alarmUnidata = true;
            }
            i++;
          }
          this.setState({ pageLoaded: 1, monitoring: monitoring, showMonitoring: true, alarmUnidata: alarmUnidata });
        },
        error: (httpReq, status, exception) => {
          this.checkLoginStatus();
        },
      });
    }, 1000);
  }

  removeAlarm(alarm) {
    $.ajax({
      method: 'POST',
      url: this.state.tunnel.URL + '/alarms/json',
      headers: {
        'x-session': this.props.token,
      },
      data: JSON.stringify({
        Command: 'Remove',
        Id: parseInt(alarm.Id, 10),
      }),
      xhrFields: {
        withCredentials: true
      },
      dataType: 'JSON',
      success: (res) => {
        // Rimosso allarme
      },
      error: (httpReq, status, exception) => {
        this.checkLoginStatus();
      },
    });
  }

  render() {
    return (
      <BaseTemplate>
        <ul className="breadcrumbs">
          <li><NavLink key="devices" to="/devices">Dispositivi</NavLink></li>
        </ul>
        <h1>{ this.state.device.Description }</h1>
        <div className="single-device">
          <div className="single-device__topbar">
            Applicazioni
            <a className="single-device__topbar__btn" href={this.state.tunnel.URL} target="_blank">
              <FontAwesome name="cogs" />
              <span className="single-device__topbar__btn__tooltip">Gestione dispositivo</span>
            </a>
          </div>
          <div className="single-device__content">
            { this.renderApps() }
          </div>
        </div>

        <div className="single-device">
          <div className="single-device__topbar">
            Dispositivi connessi
          </div>
          <div className="single-device__content single-device__content--subdevices">
            { this.renderSubdevices() }
          </div>
        </div>

        <div className="single-device">
          <div className="single-device__topbar">
            Monitoraggio
          </div>
          <div className="single-device__content single-device__content--monitoring">
            { this.renderMonitoring() }
          </div>
        </div>

        { this.renderOverlay() }

        { this.renderLoaderPage() }
      </BaseTemplate>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/SingleDevice.js